import methods from './methods'
import props from './props'
import computed from './computed'

export default {
  methods,
  props,
  computed,

  resourcePath: '/v1/professional/schedules/'
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/reverser/resources/index.js